import AuthenticationActions from "../../actions/AuthenticationActions";
import AuthenticationStore from "../../stores/AuthenticationStore";
import Link from "../NavLink";
import logo from "./logo.png";
import React from "react";
import { translate } from "react-polyglot";
import { withRouter } from "react-router-dom";

class Nav extends React.Component {
  state = {
    loggedIn: AuthenticationStore.loggedIn(),
    mobileMenuVisible: false,
  };

  componentDidMount() {
    AuthenticationStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthenticationStore.removeChangeListener(this.onChange);
  }

  closeCurrentWindow() {
    window.open("", "_self", ""); // hack to close the window/browser
    window.close();
  }

  logout = () => {
    AuthenticationActions.logout();
    this.toggleMobileMenu();

    const { history } = this.props;
    history.push("/");
  };

  onChange = () => {
    this.setState({
      loggedIn: AuthenticationStore.loggedIn(),
    });
  };

  toggleMobileMenu = () => {
    this.setState({
      mobileMenuVisible: !this.state.mobileMenuVisible,
    });
  };

  render() {
    const { t } = this.props;
    const styleMobileMenuItem = this.state.mobileMenuVisible
      ? { padding: 5 }
      : null;

    var mobileMenuClass = "collapse navbar-collapse";
    if (!this.state.mobileMenuVisible) mobileMenuClass += " hidden-xs";

    return (
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle"
              onClick={this.toggleMobileMenu}
            >
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <span className="navbar-brand">
              <Link to={this.state.loggedIn ? "/" : "/login"}>
                <img alt="e-guma Ticket" style={{ height: 70 }} src={logo} />
              </Link>
            </span>
          </div>
          <div className={mobileMenuClass} style={{ display: "block" }}>
            <ul className="nav navbar-nav navbar-right">
              {this.state.loggedIn && (
                <li style={styleMobileMenuItem}>
                  <Link to={"/events"} onClick={this.toggleMobileMenu}>
                    {t("events")}
                  </Link>
                </li>
              )}
              {this.state.loggedIn && (
                <li style={styleMobileMenuItem}>
                  <Link to={"/tickets"} onClick={this.toggleMobileMenu}>
                    {t("allTickets")}
                  </Link>
                </li>
              )}
              {this.state.loggedIn && (
                <li style={styleMobileMenuItem}>
                  <Link to={"/settings"} onClick={this.toggleMobileMenu}>
                    {t("settings")}
                  </Link>
                </li>
              )}
              {this.state.loggedIn ? (
                <li style={styleMobileMenuItem}>
                  <Link to="#" onClick={this.logout}>
                    {t("logout")}
                  </Link>
                </li>
              ) : (
                <li style={styleMobileMenuItem}>
                  <Link to={"/login"} onClick={this.toggleMobileMenu}>
                    {t("login")}
                  </Link>
                </li>
              )}
              <li style={styleMobileMenuItem}>
                <a href="#" onClick={this.closeCurrentWindow}>
                  {t("close")}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default withRouter(translate()(Nav));
